// Polyfills for Node.js modules in browser
import { Buffer } from 'buffer';

// Make Buffer available globally for libraries that expect it
window.Buffer = Buffer;
globalThis.Buffer = Buffer;
